import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useAxiosInterceptor } from './content/pages/Components/Logout/AxiosInterceptor';
import axios from 'axios';
import SessionManager from './content/pages/Components/Login/SessionManager';
import VersionUpdateBanner from 'src/components/VersionUpdateBanner';
import FeedbackWidget from './content/applications/Helpdesk/Widget/FeedbackWidget';
function App() {
  useAxiosInterceptor();
  const content = useRoutes(router);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    // SessionManager and useAxiosInterceptor handle auth logic.
    // This file now focuses on general app initialization and providers.
  }, []);

  return (
    <ThemeProvider>
      <VersionUpdateBanner />
      <SessionManager>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          {content}
          <FeedbackWidget />
        </LocalizationProvider>
      </SessionManager>

    </ThemeProvider>
  );
}
export default App;
